import { DayAPI } from '../../../api/datamanager/DayAPI';

export class DaysCommand {
    getAll(calendars, fromDate, toDate, provider, successCallback, errorCallback) {
        const parsedCalendars = undefined === calendars || null === calendars || "" === calendars ? "0" : calendars;

        const apiResult = DayAPI.list(parsedCalendars, fromDate, toDate, provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Dias dos Calendários selecionados");
            }
        });
    }

    save(day, successCallback, errorCallback) {
        const data = {
            id: day.id,
            name: day.name,
            date: day.date,
            calendarId: day.calendarId,
            dayTypeId: day.dayType.id,
            dayTypeName: day.dayType.name
        }

        const apiResult = DayAPI.update(day.id, data);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Dia editado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(calendarId, dayId, successCallback, errorCallback) {
        const apiResult = DayAPI.delete(calendarId, dayId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Dia eliminado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
